export default {
  updateLingue(state, data) {
    state.languagesObj = data;
    var arr = [];
    data.forEach((valore) => {
      arr.push([valore.value, valore.label, valore.state, valore.prefix]);
    });
    state.languages = arr;
  },

  setLingueENazioni(state, data) {
    var risultato = [];
    var langIds = [];
    var lang_arr = [];
    var tmp = {};
    for (const key in data) {
      // momentanea ripetizione per garantire la compatibilità
      tmp.lang = data[key].nomeLingua;
      tmp.label = data[key].nomeLingua;
      tmp.idLang = data[key].idLingua;
      tmp.idState = data[key].idNazione;
      tmp.state = data[key].nomeNazione;

      if (tmp.idLang == 1) {
        tmp.iso33 = "IT";
        tmp.value = "IT";
      } else if (tmp.idLang == 3) {
        tmp.iso33 = "DE";
        tmp.value = "DE";
      } else {
        tmp.iso33 = "GB";
        tmp.value = "GB";
      }
      //! languages collection
      if (!langIds.includes(tmp.idLang)) {
        langIds.push(tmp.idLang);
        lang_arr.push({
          lang: tmp.lang,
          idLang: tmp.idLang,
          iso33: tmp.iso33,
        });
      }
      tmp.prefix = "+39";
      risultato.push(tmp);
      tmp = {};
    }
    state.onlyLangObj = lang_arr.filter((itm, pos, arr) => {
      return arr.indexOf(itm) === pos;
    });
    //! possibile fare un array simile a quello che usavamo
    //! oppure adattare l'oggetto alla form o altra soluzione che non mi viene in mente
    state.languagesObj = risultato;
  },
};
